import { Theme } from "@mui/material";
import { IFormCheckBox } from "../../../services/custom-forms-data-service/TemplateModels";
import FormCheckbox from "../../forms/form-checkbox/FormCheckbox";
import FormProperty from "../../forms/form-property/FormProperty";
import { SxProps } from "@mui/system";

export type CustomFormCheckBoxProps = {
    checkbox: IFormCheckBox;
    key?: React.Key | null | undefined;
    sx?: SxProps<Theme>;
};


export default function CustomFormCheckBox({
    checkbox,
    key,
    sx
}: CustomFormCheckBoxProps) {

     return (

        <FormProperty key={key} sx={sx}>
            <FormCheckbox
                name={checkbox.name}
                ariaLabel={checkbox.ariaLabel}
                label={checkbox.label}
                readOnly={checkbox.readOnly}
            />
        </FormProperty>
    );
}
